export const navigationLinks = [
  { name: "Home", href: "/" },
  { name: "About UMED", href: "/about" },
  {
    name: "Services",
    href: "/services",
    dropdown: [
      { name: "Deaddiction Treatment", href: "/services/deaddiction", desc: "Alcohol, drug & habit recovery" },
      { name: "Mental Health & Psychiatric Care", href: "/services/mental-health-care", desc: "Psychiatric evaluation & stabilization" },
      { name: "Intellectual Disability Care", href: "/services/intellectual-disability", desc: "Long-term residential support" },
      { name: "Brain & Cognitive Disorders", href: "/services/brain-disorders", desc: "Dementia & neurocognitive care" },
      { name: "Sexual Health & Disorders", href: "/services/sexual-disorders", desc: "Confidential medical consultations" },
      { name: "Counselling Services", href: "/services/counselling-therapy", desc: "Individual & group guidance" },
      { name: "Evidence-Based Psychotherapy", href: "/services/psychotherapy", desc: "CBT, REBT & insight therapy" },
      { name: "Specialized Biological Therapies", href: "/services/specialized-therapies", desc: "ECT & cerebral stimulation" },
      { name: "Medical Support & Pharmacotherapy", href: "/services/medical-support", desc: "24/7 medication & IV support" },
      { name: "Rehabilitation & Wellness", href: "/services/psychiatric-rehabilitation", desc: "Yoga, fitness & recreation" },
    ]
  },
  { name: "Facility", href: "/facility" },
  { name: "Team", href: "/team" },
  { name: "Patient & Family", href: "/patient-family" },
  { name: "Case Studies", href: "/resources" },
  { name: "Contact", href: "/contact" },
];

export const footerQuickLinks = [
  { name: "About UMED", href: "/about" },
  { name: "Our Multidisciplinary Team", href: "/team" },
  { name: "Facility Infrastructure", href: "/facility" },
  { name: "Admissions & Family Guide", href: "/patient-family" },
  { name: "Case Studies & Articles", href: "/resources" },
  { name: "Contact & Directions", href: "/contact" }
];
